import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { NOTIFICATION_SERVICE } from '@eggplant/api-hosts'
import type {
  Error,
  GetTestManagementToolPushHistoryRequestParams,
  GetTestManagementToolPushHistoryResponse
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  params?: GetTestManagementToolPushHistoryRequestParams
  shortErrorMessage?: string
  onError?: (error: Error) => void
  onSuccess?: (response: GetTestManagementToolPushHistoryResponse) => void
  children?: (response: GetTestManagementToolPushHistoryResponse) => ReactElement
}

const GetTestManagementToolPushHistoryRequest = ({
  params,
  shortErrorMessage,
  onError,
  onSuccess,
  children
}: Props) => {
  const url = `${NOTIFICATION_SERVICE}/outbox`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      params={params}
      shortErrorMessage={shortErrorMessage}
      url={url}
    />
  )
}

export default GetTestManagementToolPushHistoryRequest
